// REACT & REACT HOOKS
import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// STORE ACTIONS
import { getCurrentUser } from "store/actions";

// CONFIG
import { REACT_APP_URL } from "./config";

// COMPONENTS
import Loader from "./components/shared/loader";
import Layout from "./components/Layout/layout";

// ROUTES
import AppRoutes from "./routes";
import AuthRoutes from "./routes/authRoutes";

const App = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");

    const { isLoggedIn } = useSelector((state) => state?.authentication);
    const { settings } = useSelector((state) => state.settings);

    const logo = REACT_APP_URL + settings?.appLogo;

    useEffect(() => {
        if (token) dispatch(getCurrentUser());
    }, [token, dispatch]);

    const RenderApp = () => (
        <Suspense fallback={<div>Loading...</div>}>
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout logo={logo} />}>
                        {AppRoutes()}
                    </Route>
                    {AuthRoutes()}
                </Routes>
            </BrowserRouter>
        </Suspense>
    );

    if (!token) return RenderApp();
    if (isLoggedIn !== null) return RenderApp();
    return <Loader full />;
};

export default App;
